// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../../css/App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slot-word-container {
    position: absolute;
    width: 100%;
    display: flex;
    justify-content: center;
    font-family: "Roboto";
    font-weight: 700;
    z-index: -1;
}

.slot-word {
    display: flex;
    font-size: clamp(12pt, 9vw, 40pt);
    font-family: inherit;
    cursor: pointer;
    width: fit-content;
    height: fit-content;
    gap: 1px;
}

    .slot-word > .slot {
        display: inline-block;
        overflow: visible;
        height: auto;
        opacity: 0;
        line-height: 1em;
        animation-name: dropIn;
        animation-duration: 0.5s;
        animation-direction: normal;
        animation-fill-mode: forwards;
        animation-timing-function: ease;
        user-select: none;
        background-color: var(--color-component-transparent-background);
        border-radius: 4px;
    }

        .slot-word > .slot:nth-child(1) {
            animation-delay: 0.05s;
        }

        .slot-word > .slot:nth-child(2) {
            animation-delay: 0.1s;
        }

        .slot-word > .slot:nth-child(3) {
            animation-delay: 0.15s;
        }

        .slot-word > .slot:nth-child(4) {
            animation-delay: 0.2s;
        }

        .slot-word > .slot:nth-child(5) {
            animation-delay: 0.25s;
        }

        .slot-word > .slot:nth-child(6) {
            animation-delay: 0.3s;
        }

        .slot-word > .slot:nth-child(7) {
            animation-delay: 0.35s;
        }

        .slot-word > .slot:nth-child(8) {
            animation-delay: 0.4s;
        }

        .slot-word > .slot:nth-child(9) {
            animation-delay: 0.45s;
        }

        .slot-word > .slot:nth-child(10) {
            animation-delay: 0.5s;
        }

        .slot-word > .slot:nth-child(11) {
            animation-delay: 0.55s;
        }

        .slot-word > .slot:hover {
            transform: scale(1.03);
            transition: transform 0.2s ease;
        }

@keyframes dropIn {
    0% {
        transform: translateY(-100%) rotate(-25deg);
        opacity: 0;
    }

    60% {
        transform: translateY(10%) rotate(-15deg);
        opacity: 0.6;
    }

    80% {
        transform: translateY(-10%) rotate(5deg);
        opacity: 0.8;
    }

    100% {
        transform: translateY(0% rotate(0deg));
        opacity: 1;
    }
}
`, "",{"version":3,"sources":["webpack://./src/Title/css/AnimatedTitleComponent.css"],"names":[],"mappings":"AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,iCAAiC;IACjC,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,QAAQ;AACZ;;IAEI;QACI,qBAAqB;QACrB,iBAAiB;QACjB,YAAY;QACZ,UAAU;QACV,gBAAgB;QAChB,sBAAsB;QACtB,wBAAwB;QACxB,2BAA2B;QAC3B,6BAA6B;QAC7B,+BAA+B;QAC/B,iBAAiB;QACjB,+DAA+D;QAC/D,kBAAkB;IACtB;;QAEI;YACI,sBAAsB;QAC1B;;QAEA;YACI,qBAAqB;QACzB;;QAEA;YACI,sBAAsB;QAC1B;;QAEA;YACI,qBAAqB;QACzB;;QAEA;YACI,sBAAsB;QAC1B;;QAEA;YACI,qBAAqB;QACzB;;QAEA;YACI,sBAAsB;QAC1B;;QAEA;YACI,qBAAqB;QACzB;;QAEA;YACI,sBAAsB;QAC1B;;QAEA;YACI,qBAAqB;QACzB;;QAEA;YACI,sBAAsB;QAC1B;;QAEA;YACI,sBAAsB;YACtB,+BAA+B;QACnC;;AAER;IACI;QACI,2CAA2C;QAC3C,UAAU;IACd;;IAEA;QACI,yCAAyC;QACzC,YAAY;IAChB;;IAEA;QACI,wCAAwC;QACxC,YAAY;IAChB;;IAEA;QACI,sCAAsC;QACtC,UAAU;IACd;AACJ","sourcesContent":["@import '../../css/App.css';\r\n\r\n.slot-word-container {\r\n    position: absolute;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    font-family: \"Roboto\";\r\n    font-weight: 700;\r\n    z-index: -1;\r\n}\r\n\r\n.slot-word {\r\n    display: flex;\r\n    font-size: clamp(12pt, 9vw, 40pt);\r\n    font-family: inherit;\r\n    cursor: pointer;\r\n    width: fit-content;\r\n    height: fit-content;\r\n    gap: 1px;\r\n}\r\n\r\n    .slot-word > .slot {\r\n        display: inline-block;\r\n        overflow: visible;\r\n        height: auto;\r\n        opacity: 0;\r\n        line-height: 1em;\r\n        animation-name: dropIn;\r\n        animation-duration: 0.5s;\r\n        animation-direction: normal;\r\n        animation-fill-mode: forwards;\r\n        animation-timing-function: ease;\r\n        user-select: none;\r\n        background-color: var(--color-component-transparent-background);\r\n        border-radius: 4px;\r\n    }\r\n\r\n        .slot-word > .slot:nth-child(1) {\r\n            animation-delay: 0.05s;\r\n        }\r\n\r\n        .slot-word > .slot:nth-child(2) {\r\n            animation-delay: 0.1s;\r\n        }\r\n\r\n        .slot-word > .slot:nth-child(3) {\r\n            animation-delay: 0.15s;\r\n        }\r\n\r\n        .slot-word > .slot:nth-child(4) {\r\n            animation-delay: 0.2s;\r\n        }\r\n\r\n        .slot-word > .slot:nth-child(5) {\r\n            animation-delay: 0.25s;\r\n        }\r\n\r\n        .slot-word > .slot:nth-child(6) {\r\n            animation-delay: 0.3s;\r\n        }\r\n\r\n        .slot-word > .slot:nth-child(7) {\r\n            animation-delay: 0.35s;\r\n        }\r\n\r\n        .slot-word > .slot:nth-child(8) {\r\n            animation-delay: 0.4s;\r\n        }\r\n\r\n        .slot-word > .slot:nth-child(9) {\r\n            animation-delay: 0.45s;\r\n        }\r\n\r\n        .slot-word > .slot:nth-child(10) {\r\n            animation-delay: 0.5s;\r\n        }\r\n\r\n        .slot-word > .slot:nth-child(11) {\r\n            animation-delay: 0.55s;\r\n        }\r\n\r\n        .slot-word > .slot:hover {\r\n            transform: scale(1.03);\r\n            transition: transform 0.2s ease;\r\n        }\r\n\r\n@keyframes dropIn {\r\n    0% {\r\n        transform: translateY(-100%) rotate(-25deg);\r\n        opacity: 0;\r\n    }\r\n\r\n    60% {\r\n        transform: translateY(10%) rotate(-15deg);\r\n        opacity: 0.6;\r\n    }\r\n\r\n    80% {\r\n        transform: translateY(-10%) rotate(5deg);\r\n        opacity: 0.8;\r\n    }\r\n\r\n    100% {\r\n        transform: translateY(0% rotate(0deg));\r\n        opacity: 1;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
